import React from 'react';
import PropTypes from 'prop-types';

import PublicMaster from '../master/Public';
import PrincipalMaster from '../master/Principal';
import { Utils } from '../../services';

const styles = {
    center: {
        textAlign: 'center',
    },
    errorNumberStyle: {
        fontSize: 96,
    },
};

const CustomError = props => (
    Utils.getUsuarioEstaLogado() ?
        <PrincipalMaster title={props.title}>
            <ErrorLayout {...props} />
        </PrincipalMaster> :
        <PublicMaster title={props.title}>
            <ErrorLayout {...props} />
        </PublicMaster>
);

CustomError.propTypes = {
    title: PropTypes.string.isRequired,
};

const ErrorLayout = props => (
    <div style={styles.center}>
        <h1 style={styles.errorNumberStyle}>{props.errorNumber}</h1>
        <h2 style={styles.errorTextStyle}>{props.errorText}</h2>
    </div>
);

ErrorLayout.propTypes = {
    errorNumber: PropTypes.number.isRequired,
    errorText: PropTypes.string.isRequired,
};

export default CustomError;
